

export const FETCH_PHOTOGRAPHERS_REQUEST = 'FETCH_PHOTOGRAPHERS_REQUEST';
export const FETCH_PHOTOGRAPHERS_SUCCESS = 'FETCH_PHOTOGRAPHERS_SUCCESS';
export const FETCH_PHOTOGRAPHERS_FAILURE = 'FETCH_PHOTOGRAPHERS_FAILURE';

export const fetchPhotographersRequest = () => {
  return{
    type: FETCH_PHOTOGRAPHERS_REQUEST
  };
};

export const fetchPhotographersSuccess = photographers => {
  return {
    type: FETCH_PHOTOGRAPHERS_SUCCESS,
    photographers
  };
};
export const fetchPhotographersFailure = error => {
  return {
    type: FETCH_PHOTOGRAPHERS_FAILURE,
    error
  };
};

export const fetchPhotographers = () => {
  return dispatch => {
    dispatch(fetchPhotographersRequest());

    return fetch(`${apiBase}/wp/v2/photographers?per_page=99`)
      .then(response => response.json())
      .then(json => dispatch(fetchPhotographersSuccess(json)));
  };
};
